export const LIBRIS_CATEGORY_ID = 'Category_aebc60910afe70fc';
export const LIBRIS_COLOR_OPTIONS = [
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Blue_5daf3a2b4db76892',
    option: 'Blue',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Brown_335f2fa49026c77b',
    option: 'Brown',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Black_91cc4b445ada5eb3',
    option: 'Darks/Black',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Green_9aad36ec87680948',
    option: 'Green',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Metallic_c2e50d51c5023be9',
    option: 'Metallic',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Multicolor_8136286bbb40eabc',
    option: 'Multicolor',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Neutral-Gray_52b4deeca05c2e12',
    option: 'Neutral/Gray',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Orange_6844e3c10955abd1',
    option: 'Orange',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Pink_1b1e137c43f4b939',
    option: 'Pink',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Purple_350b08ce304b2dab',
    option: 'Purple',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Red_021c82239b4da8fa',
    option: 'Red',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'White_239995f72da07f48',
    option: 'White',
  },
  {
    field_id: 'Color_56b72def9286a02b',
    option_id: 'Yellow_051d4430513277b5',
    option: 'Yellow',
  },
];

export const LIBRIS_COLLECTION_OPTIONS = [
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'Animals_81c938a487e1c3e1',
    option: 'animals',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'Architecture_0387134d0e9672f5',
    option: 'architecture',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'People_3c4a9c9f6b312d5d',
    option: 'people',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'landscape_b5d47df24ae6a64e',
    option: 'landscape',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'cityscape_6055c4c2cd1d6e47',
    option: 'cityscape',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'still-life_41dcd4f4829e49da',
    option: 'Still Life',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'abstract_9456adcf75ac205f',
    option: 'abstract',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'floral_da9eab0616a6d882',
    option: 'floral',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'nature_9add0f6a89ced4e8',
    option: 'nature',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'stones_5c5db64292cb9497',
    option: 'stones',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'textures-patterns_fbded5c0973cd969',
    option: 'textures & Patterns',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'woods_5712b97234ff0ce7',
    option: 'woods',
  },
  {
    field_id: 'Category_aebc60910afe70fc',
    option_id: 'Watercolor_16c1e4ca2ada450c',
    option: 'watercolor',
  },
];
